"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageContainer = exports.Image = void 0;
var _Utils = require("../Utils");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
const Image = exports.Image = _styledComponents.default.img(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100%;\n"])));
const ImageContainer = exports.ImageContainer = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    border: 1px solid ", ";\n    max-width: 100%;\n    overflow-y: auto;\n    ", "\n"])), (0, _Utils.getTheme)('primaryColor'), (0, _Utils.ifProp)('fullSizeImage', 'box-sizing: border-box; width: 100%;'));